// extracted by mini-css-extract-plugin
module.exports = {"singleResourcePage":"style_singleResourcePage__29v0W g-grid-container","pageLane":"style_pageLane__cOQBn","contentLane":"style_contentLane__8yFN3"};